var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            [
              _c(
                "v-card",
                { staticClass: "mt-4", attrs: { outlined: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c("loading-linear", {
                        attrs: { message: "Loading Relevant Graphics ..." },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        [
          _vm.displaySection && !_vm.isMobilePort
            ? _c(
                "divider-expand",
                {
                  attrs: {
                    "open-by-default": _vm.defaultExpand,
                    activateSearchTab: this.$getConst("graphicsSearchType"),
                    buttonText: "See More Graphics",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "expand",
                        fn: function () {
                          return [
                            _c(
                              "v-row",
                              { attrs: { dense: "" } },
                              _vm._l(_vm.results, function (item, key) {
                                return _c(
                                  "v-col",
                                  { key: key },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass: "fill-height",
                                        attrs: { outlined: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getGraphicDetails(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "img-block-height d-flex justify-center align-center",
                                            on: {
                                              contextmenu: (event) =>
                                                _vm.handleRightClick(
                                                  event,
                                                  item.document_sku
                                                ),
                                            },
                                          },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                staticStyle: {
                                                  position: "absolute",
                                                  "z-index": "2",
                                                  top: "2px",
                                                  right: "2px",
                                                },
                                                attrs: {
                                                  color: "white",
                                                  size: "20",
                                                },
                                              },
                                              [
                                                _c("access-icon", {
                                                  attrs: {
                                                    "access-level":
                                                      _vm.getAccessLevel(
                                                        item.document_sku,
                                                        item.content_access_level_id
                                                      ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("img", {
                                              attrs: {
                                                src: item.figure_url,
                                                alt:
                                                  item.alt_text.length > 0
                                                    ? item.alt_text
                                                    : `${item.section_title} Graphic`,
                                                height: "50",
                                                width: "50",
                                              },
                                              on: {
                                                error: _vm.loadPlaceholderImage,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3619838625
                  ),
                },
                [
                  _c(
                    "p",
                    { staticClass: "fs-14 mb-0 d-inline font-weight-medium" },
                    [_vm._v("\n            Relevant Graphics (Beta)\n        ")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }